module.exports = __webpack_public_path__ + "officialStatic/img/olt-detailList13.cd88f80.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/product/detail/olt-detailList13.png
// module id = 7ICh
// module chunks = 0